"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDateRange = initDateRange;
exports.initTodayDateRange = initTodayDateRange;
exports.initWeekDateRange = initWeekDateRange;
exports.initYesterdayDateRange = initYesterdayDateRange;
require("core-js/modules/es7.string.pad-start");
function initYesterdayDateRange() {
  var currentDate = new Date();
  var yesterdayDate = new Date();
  yesterdayDate.setDate(currentDate.getDate() - 1);
  var year = yesterdayDate.getFullYear(); // 获取年份
  var month = String(yesterdayDate.getMonth() + 1).padStart(2, '0'); // 获取月份，注意月份是从 0 开始计数的，因此需要加 1
  var day = String(yesterdayDate.getDate()).padStart(2, '0'); // 获取日期
  var date = "".concat(year, "-").concat(month, "-").concat(day); // 格式化日期
  var thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(yesterdayDate.getDate() - 30);
  var year30 = thirtyDaysAgo.getFullYear(); // 获取年份
  var month30 = String(thirtyDaysAgo.getMonth() + 1).padStart(2, '0'); // 获取月份，注意月份是从 0 开始计数的，因此需要加 1
  var day30 = String(thirtyDaysAgo.getDate()).padStart(2, '0'); // 获取日期
  var date30 = "".concat(year30, "-").concat(month30, "-").concat(day30); // 格式化日期
  this.searchForm.pay_date = [date30, date];
}
function initDateRange() {
  var currentDate = new Date();
  var year = currentDate.getFullYear(); // 获取年份
  var month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 获取月份，注意月份是从 0 开始计数的，因此需要加 1
  var day = String(currentDate.getDate()).padStart(2, '0'); // 获取日期
  var date = "".concat(year, "-").concat(month, "-").concat(day); // 格式化日期
  var thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(currentDate.getDate() - 30);
  var year30 = thirtyDaysAgo.getFullYear(); // 获取年份
  var month30 = String(thirtyDaysAgo.getMonth() + 1).padStart(2, '0'); // 获取月份，注意月份是从 0 开始计数的，因此需要加 1
  var day30 = String(thirtyDaysAgo.getDate()).padStart(2, '0'); // 获取日期
  var date30 = "".concat(year30, "-").concat(month30, "-").concat(day30); // 格式化日期
  this.searchForm.created_at = [date30, date];
}
function initWeekDateRange() {
  var currentDate = new Date();
  var year = currentDate.getFullYear(); // 获取年份
  var month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 获取月份，注意月份是从 0 开始计数的，因此需要加 1
  var day = String(currentDate.getDate()).padStart(2, '0'); // 获取日期
  var date = "".concat(year, "-").concat(month, "-").concat(day); // 格式化日期
  var thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(currentDate.getDate() - 7);
  var year7 = thirtyDaysAgo.getFullYear(); // 获取年份
  var month7 = String(thirtyDaysAgo.getMonth() + 1).padStart(2, '0'); // 获取月份，注意月份是从 0 开始计数的，因此需要加 1
  var day7 = String(thirtyDaysAgo.getDate()).padStart(2, '0'); // 获取日期
  var date7 = "".concat(year7, "-").concat(month7, "-").concat(day7); // 格式化日期
  this.searchForm.created_at = [date7, date];
}
function initTodayDateRange() {
  var currentDate = new Date();
  var year = currentDate.getFullYear(); // 获取年份
  var month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 获取月份，注意月份是从 0 开始计数的，因此需要加 1
  var day = String(currentDate.getDate()).padStart(2, '0'); // 获取日期
  var date = "".concat(year, "-").concat(month, "-").concat(day); // 格式化日期
  this.searchForm.created_at = [date, date];
}